import React from "react"
import Link from "gatsby-link"
import styled, { ThemeProvider } from "styled-components"
import "whatwg-fetch"
import * as vars from "../style/vars"
import { maxHeight, below } from "../style/functions"
import Input from "./input"
import Autofill from "./autofill"
import suburbsData from "../data/suburbs.js"
import FileSaver, { saveAs } from 'file-saver';

import { colors } from "../style/vars"
import circleArrow from "../svg/right-circle-white.svg"

const theme = {
   color: colors.inactiveColor,
   backgroundColor: "transparent",
   paddingLeft: "1rem",
   fontSize: "1.5rem"
}

class DevelopmentUpdateForm extends React.Component {
   constructor() {
      super()
      let url
      if (typeof window !== `undefined`) {
         url = window.location.href
            .replace("https://", "")
            .replace("http://", "")
            .replace(/\/$/, "")
      } else {
         url = ""
      }
      this.state = {
         formStatus: "incomplete",
         values: {},
         url: url,
         declineSuburb: false
      }
   }
   updateForm(e) {
      let values = this.state.values
      if (e.target.getAttribute("name") !== "Postcode") {
         values[e.target.getAttribute("name")] = e.target.value
         this.setState({ values })
      } else {
         return false
      }
   }

   componentDidMount() {

      this.updateForm = this.updateForm.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
   }


   handleSubmit(e) {
      e.preventDefault()
      var submitBtn = document.getElementById("submit")
      submitBtn.style.cursor = "progress";
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'LOADING';
      const fields = [].slice.call(e.target.querySelectorAll("[name]"))
      fields.map(f => {
         let values = this.state.values
         values[f.getAttribute("name")] = f.value
      })
      var values = { ...this.state.values };



// console.log(values);

      fetch(
         "https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/yarrabend-mailchimp-development-updates",
         {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(values)
         }
      )
         .then(res => res.json())
         .then(json => {
            if (json.errorMessage) {
               alert('Error submitting request please call +61 (0)3 9573 8320')
            } else {
               let formStatus = "complete"
               this.setState({ formStatus })
            }
         })
         .catch(err => console.log(err))


   }
   render() {



      return (
         <Container popup={this.props.popup} shown={this.props.shown}>
            {this.props.popup && <Close onClick={this.props.toggleForm} />}
            {this.state.formStatus === "complete" ? (
               <div>

                  <ThankYouText className={'form__thankyou'}>
                  Thank you your registration was successfully submitted.
                  </ThankYouText>
               </div>
            ) : (
                  <ThemeProvider theme={theme}>
                     <div>

                        <Form action="" onSubmit={this.handleSubmit}>

                           {/* <Logo alt="YarraBend" src="/svg/logo-icon.svg"/> */}
                           {/* <Heading>Register your interest</Heading> */}
                           <Field>
                              <Input
                                 name="first_name"
                                 label="First Name"
                                 required
                                 onChange={this.updateForm}
                              />
                           </Field>
                           <Field>
                              <Input
                                 name="last_name"
                                 label="Surname"
                                 required
                                 onChange={this.updateForm}
                              />
                           </Field>

                           <FieldFull>
                              <Input
                                 name="email"
                                 label="Email address"
                                 required
                                 onChange={this.updateForm}
                              />
                           </FieldFull>


                              <Submit id="submit" square={this.props.square}><span>Keep me updated</span></Submit>

                        </Form>
                     </div>
                  </ThemeProvider>
               )}
         </Container>
      )
   }
}

export default DevelopmentUpdateForm

const Container = styled.div`

.form__thankyou a:not(.link-email):after {
   content: url(/svg/arrow.svg)!important;
}

.form__thankyou .buttonWrapper{
   padding-top:2em;
   display:block;
}
`

const Close = styled.div`
  height: 4rem;
  width: 4rem;
  position: absolute;
  top: 3rem;
  right: 3rem;
  color: ${colors.blank};
  cursor: pointer;
	transition: color ${vars.time};

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: currentColor;
    position: absolute;
    top: 50%;
    left: 0;
    transform: rotate(45deg);
  }
  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: currentColor;
    position: absolute;
    top: 50%;
    left: 0;
    transform: rotate(-45deg);
  }
	&:hover{
		color: #66523e;

	}
`


const Form = styled.form`
   width: 90%;
   max-width: 76rem;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: space-between;
   .btn {
      margin: ${vars.padding.inner}rem auto auto auto;
      flex-basis: 53%;
   }
   ${below.tablet`
		max-width: 100%;
		width: 100%;
	`}
   ${below.mobile`
    padding-top: 0;
    display:block;
  `};
`

const Field = styled.div`
   border-bottom: 1px solid ${colors.inactiveColor};
   width: calc(50% - 1rem);
   display: inline-block;
   margin-bottom: 0rem;
   @supports (display: flex) {
      display: block;
   }

   ${below.mobile`
		width: 100%;
		margin-left: auto;
		margin-right: auto;
    display:block;
    margin-bottom: 0;
	`};
`

const FieldFull = styled.div`
   border-bottom: 1px solid ${colors.inactiveColor};
   width: calc(100%);
   display: inline-block;
   margin-bottom: 0rem;
   @supports (display: flex) {
      display: block;
   }

   ${below.mobile`
		width: 100%;
		margin-left: auto;
		margin-right: auto;
    display:block;
    margin-bottom: 0;
	`};
`

const Submit = styled.button`
   position: relative;
   width: auto;
   flex: 0 0 auto;
   text-align: left;
   font-size: 1.4rem;
   background: ${colors.body};
   color: ${colors.blank};
   text-decoration: underline;
   margin-top: ${vars.padding.inner / 2}rem;
   padding: 1.2rem 1.75rem;
   cursor: pointer;
   transition: margin-left .3s;
   text-decoration: none;

   :after {
      content: '→';
      margin-left: .5rem;
      transition: margin-left .5s;
      text-decoration: none;
   }

   :hover:after {
      margin-left: .9rem;
   }

   span {
      text-decoration: underline;
   }
`

const Heading = styled.p`
  padding: 1rem 0;

  /* width: 100%; */
  /* font-family: "Salome Fine"; */
  /* color: ${colors.brandHighlight}; */
  /* text-transform: uppercase; */
  /* font-size: 3rem; */
  /* text-align: center; */
  /* margin-bottom: 3rem; */
`

const ThankYouText = styled.p`
  /* font-size: 1.5rem; */
  /* color: ${colors.white}; */
  /* text-align: center; */
`

const FormNote = styled.p`
   text-transform: uppercase;
   color: ${colors.brandHighlight};
   text-align: center;
   width: 100%;
   margin-top: 2rem;
   font-size: 1.4rem;
`

const Logo = styled.img`
   width: 14em;
   width: 14em;
   display: block;
   position: relative;
   margin: 0 auto 3em;
`

const FormError = styled.p`

    padding: 1em;
    background-color: #dc3545;
    color: #fff;
    margin-bottom: 2em;

`



// WEBPACK FOOTER //
// ./src/components/developmentUpdateForm.js